import { Component, Input, Output, EventEmitter, HostListener, forwardRef, OnChanges, SimpleChanges, ContentChild, TemplateRef, Optional, Self, ElementRef, ChangeDetectorRef } from '@angular/core';
import { ControlValueAccessor, FormGroup, NG_VALUE_ACCESSOR, NgControl } from '@angular/forms';

@Component({
  selector: 'app-dropdown',
  templateUrl: './select.component.html',
  styleUrls: ['./select.component.css'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => DropdownComponent),
      multi: true
    }
  ]
})
export class DropdownComponent implements ControlValueAccessor, OnChanges {
  constructor(private el: ElementRef<HTMLElement>, private cdr: ChangeDetectorRef) {}
  @Input() formGroup!: FormGroup;
  @Input() options: { id: any; text: string }[] = [];
  @Input() label: string | null = null;
  @Input() controlName: string | null = null;
  @Input() errorMessage: string | null = null;
  @Input() submitted: boolean = false;


  @Input() icon: string | null = null;
  @Input() searchPlaceholder: string = 'Buscar…';
  @Output() optionSelected = new EventEmitter<{ id: any; text: string }>();

  @ContentChild('optionTemplate') optionTemplate: TemplateRef<any> | undefined;  // Capture the template

  isOpen = false;
  focusedIndex: number = -1;
  selectedOption: { id: any; text: string } | null = null;
  filteredOptions: { id: any; text: string }[] = [];
  searchText: string = '';

  //   searchText: string = '';

  //   get filteredOptions() {
  //   return this.options.filter(option =>
  //     option.text.toLowerCase().includes(this.searchText.toLowerCase())
  //   );
  // }


  private tempWriteValue: any = null;

  // ControlValueAccessor methods
  onChange: any = () => { };
  onTouched: any = () => { };

  // ngOnChanges lifecycle hook
  // ngOnChanges(changes: SimpleChanges): void {
  //   if (changes['options'] && changes['options'].currentValue && changes['options'].currentValue.length > 0 && this.tempWriteValue) {
  //     // Re-set selectedOption if necessary, in case options are updated from API
  //     this.selectedOption = changes['options'].currentValue.find(option => option.id === this.tempWriteValue) || null;
  //   }
  // }

  ngOnInit() {
    if (this.options) {
      this.filteredOptions = [...this.options];
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['options']) {

      if (this.options) {
        this.filteredOptions = [...this.options];
        if (this.tempWriteValue) {
          this.selectedOption = this.options.find(option => option.id === this.tempWriteValue) || null;
        }
      }

    }
  }

  onSearchChange() {
    const lower = this.searchText.toLowerCase();

    if (this.options[0]['code']) {
      const codeMatches = this.options.filter(option =>
        option['code'].toLowerCase().includes(lower)
      );

      const textMatches = this.options.filter(option =>
        !option['code'].toLowerCase().includes(lower) &&  // prevent duplicates
        option.text.toLowerCase().includes(lower)
      );

      this.filteredOptions = [...codeMatches, ...textMatches];

    } else {
      this.filteredOptions = this.options.filter(option =>
        option.text.toLowerCase().includes(lower)
      );
    }

    // this.focusedIndex = 0;
  }
  writeValue(value: any): void {
    if (value) {
      this.tempWriteValue = value
      // Ensure the options are available before trying to select
      if (this.options && this.options.length > 0) {
        this.selectedOption = this.options.find(option => option.id === value) || null;
      }
    } else {
      this.selectedOption = null;
    }
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  toggleDropdown() {
    this.isOpen = !this.isOpen;
    if (this.isOpen) {
      this.focusedIndex = this.options.findIndex(
        (option) => option.id === this.selectedOption?.id
      );
      // Enfocar el buscador DENTRO del mismo gesto: en iOS/Android el teclado solo se abre si el foco se da
      // de forma sincrona en el clic (un setTimeout lo anula). Se busca dentro de este desplegable, no en todo el documento.
      // En movil (<768) NO se enfoca: el teclado taparia la lista; la persona toca "Buscar" si lo necesita.
      if (window.innerWidth < 768) {
        return;
      }
      this.cdr.detectChanges();
      const input = this.el.nativeElement.querySelector('.dropdown-search-input') as HTMLInputElement | null;
      if (input) {
        input.focus({ preventScroll: true });
      }
      setTimeout(() => {
        const again = this.el.nativeElement.querySelector('.dropdown-search-input') as HTMLInputElement | null;
        if (again && document.activeElement !== again) {
          again.focus({ preventScroll: true });
        }
      }, 200);

    }
  }

  onFocusOut(event: FocusEvent) {
    const relatedTarget = event.relatedTarget as HTMLElement;
    const container = event.currentTarget as HTMLElement;
    if (!container.contains(relatedTarget)) {
      this.closeDropdown();
    }
  }

  selectOption(option: { id: any; text: string }) {
    this.selectedOption = option;
    this.onChange(option.id); // Notify Angular forms of the change
    this.optionSelected.emit(option);
    this.isOpen = false;
    this.searchText = ''; // Clear search input
    this.filteredOptions = [...this.options];
  }

  closeDropdown() {
    this.isOpen = false;
    this.focusedIndex = -1;
    this.searchText = ''; // Clear search input
    this.filteredOptions = [...this.options];
  }

  handleKeyDown(event: KeyboardEvent) {
    if (this.isOpen) {
      if (event.key === 'ArrowDown') {
        event.preventDefault();
        this.focusedIndex = (this.focusedIndex + 1) % this.options.length;
      } else if (event.key === 'ArrowUp') {
        event.preventDefault();
        this.focusedIndex =
          (this.focusedIndex - 1 + this.options.length) % this.options.length;
      } else if (event.key === 'Enter') {
        event.preventDefault();
        if (this.focusedIndex >= 0) {
          this.selectOption(this.options[this.focusedIndex]);
        }
      } else if (event.key === 'Escape') {
        this.closeDropdown();
      }
    } else if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      this.toggleDropdown();
    }
  }
  // Check if the control has errors
}
